import { classNames } from '@fullstory/util/fmt';
import displayClassNames, { ClassNames as Display } from '../classes/display.module.scss';
import { getClassName } from '../utils/getClassName';

export interface DisplayProps {
  display?: Display;
}

export function getDisplayClassNames({ display }: DisplayProps = {}) {
  return classNames(getClassName(displayClassNames, display));
}
